import { useQueryClient } from "@tanstack/react-query";
import { globalConfigServices } from 'features/globalConfiguration/services/globalConfig.service';

export const usePrefetchConfig = () => {
  const queryClient = useQueryClient();

  const prefetchGlobalConfig = () => {
    queryClient.prefetchQuery({
      queryKey: ['globalConfig'],
      queryFn: () => globalConfigServices.getGlobalConfig(),
      staleTime: 5 * 60 * 1000, // 5 minutes
    });
  };

  return {
    prefetchGlobalConfig,
  };
}